module.exports = __webpack_public_path__ + "static/media/messanger.9283e39c.svg";